import React from 'react'
import PropTypes from 'prop-types'

import { RadioGroup, Radio } from 'react-radio-group'
import Tooltip from '../../tooltip/tooltip'

import styles from './license.module.css'

const onKeyDown = (onChange, key) => event => {
  if (event.key === 'Enter') {
    onChange(key)
  }
}

const License = ({ licenses, disabled, selectedLicense, onChange }) => {
  if (Object.keys(licenses).length === 1) {
    return <LicenseDetails license={licenses[selectedLicense]} />
  } else {
    return (
      <LicenseRadio
        licenses={licenses}
        selectedLicense={selectedLicense}
        onChange={onChange}
        disabled={disabled}
      />
    )
  }
}

const LicenseDetails = ({ license }) => {
  return (
    <div>
      <span className={styles.licenseName}>{license['license_label']} </span>
      <Tooltip>
        <span dangerouslySetInnerHTML={{ __html: license.description }} />
        <a className={styles.tooltipLink} href={license.terms_url}>
          &nbsp;License details
        </a>
      </Tooltip>
    </div>
  )
}

const LicenseRadio = ({ licenses, disabled, selectedLicense, onChange }) => {
  return (
    <RadioGroup selectedValue={selectedLicense} onChange={onChange}>
      {Object.keys(licenses).map(key => {
        let license = licenses[key]

        return (
          <label className={styles.label} key={key}>
            <Radio
              className={styles.radioInput}
              value={key}
              disabled={disabled}
            />
            <span
              className={styles.text}
              role="button"
              tabIndex="0"
              onKeyDown={onKeyDown(onChange, key)}
            >
              {license.license_label}{' '}
            </span>
            <Tooltip>
              <span dangerouslySetInnerHTML={{ __html: license.description }} />
              <a className={styles.tooltipLink} href={license.terms_url}>
                &nbsp;License details
              </a>
            </Tooltip>
          </label>
        )
      })}
    </RadioGroup>
  )
}

License.propTypes = {
  licenses: PropTypes.object.isRequired,
  selectedLicense: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default License
